<div [ngClass]="options.cssClasses.rootDiv">
    @for(itm of notifications; track itm)
    {
        <ng-template [messageRenderer]="itm"
                     [notificationsOptions]="options"
                     (closed)="removeItem($event)"/>
    }
</div>